import React from 'react';
import {useFormSubmit} from '../../../controllers/useSubmitForm';
import {Form} from '../../../components/form/Form';
import {getZeroTimeDate} from '@unthinkable/react-date-picker';
import {useAppStateContext} from '../../../providers/AppState';

export const LeaveRequestForm = props => {
  const {
    route: {params},
  } = props;

  const {row} = params;
  const {user} = useAppStateContext();
  const {
    employee: {_id /* reporting_to */},
  } = user;
  const {onSubmit} = useFormSubmit({
    uri: '/Requests',
    eventSourceId: ['leaveManagement'],
    ...props,
  });
  return (
    <Form
      api={`/Requests/${row?._id}`}
      fields={{
        from_date: 1,
        to_date: 1,
        duration_of_leave: 1,
        type_of_half_day: 1,
        leave_type_id: {name: 1},
        remarks: 1,
        createdAt: 1,
      }}
      onSubmit={onSubmit}
      submitAction={'Save'}
      defaultValues={{
        // duration_of_leave: 'Full Day',
        requested_on: getZeroTimeDate(new Date()),
        from_date: getZeroTimeDate(new Date()),
        to_date: getZeroTimeDate(new Date()),
        employee: _id,
      }}
      computations={{
        status: [
          value => {
            const {is_approved} = value || {};
            if (is_approved) return 'approve';
            else return 'unapproved';
          },
          ['is_approved'],
        ],
      }}
      layoutFields={[
        {
          label: 'From Date',
          field: 'from_date',
          type: 'date',
          required: true,
          size: 6,
        },
        {
          type: 'date',
          field: 'to_date',
          label: 'To Date',
          required: true,
          size: 6,
        },
        {
          label: 'Duration',
          field: 'duration_of_leave',
          type: 'autoComplete',
          options: ['Full Day', 'Half Day'],
          required: true,
          onChangeValue: (value, e, {setFieldValue}) => {
            setFieldValue(
              'type_of_half_day',
              value === 'Full Day' ? null : 'First Half',
            );
          },
          required: true,
          size: 12,
        },
        {
          label: 'First Half/Second Half',
          field: 'type_of_half_day',
          type: 'autoComplete',
          options: ['First Half', 'Second Half'],
          required: true,
          visible: ({values}) => {
            if (values && values.duration_of_leave === 'Half Day') {
              return true;
            } else {
              return false;
            }
          },
          size: 6,
        },
        {
          label: 'Leave Type',
          field: 'leave_type_id',
          type: 'autoComplete',
          api: `/currentLeaveType`,
          suggestionField: 'name',
          valueField: 'name',
          size: 6,
          required: true,
          filter: ({values}) => {
            let filter = {};
            if (values?.from_date && values?.to_date) {
              filter['from_date'] = new Date(values?.from_date);
              filter['to_date'] = new Date(values?.to_date);
            }
            return filter;
          },
        },
        {
          label: 'Reason',
          type: 'text',
          field: 'remarks',
        },
      ]}
      {...props}
    />
  );
};

export const AddLeaveRequestForm = props => {
  return <LeaveRequestForm header={'Add Leave Request'} {...props} />;
};

export const UpdateLeaveRequestForm = props => {
  return (
    <LeaveRequestForm mode="edit" header={'Update Leave Request'} {...props} />
  );
};
